export default __webpack_public_path__ + "static/oeko-tex-standard-5d1f750eb3e9bd89859287e82cb59a10.png";